import(/* webpackMode: "eager" */ "/app/app/(remote-jobs)/[lang]/remote-jobs/error.tsx");
